import {fetchPage} from "./api";
import {
	currentPage,
	makePageUrl,
	pushCurrentPage,
	renderPage,
	renderPagePublicationDate
} from "./render";

function initState() {
	const page = currentPage();
	const hash = window.location.hash;
	history.replaceState(
		"navigation" in window ? null : page,
		page.title,
		makePageUrl(page, hash !== "" ? hash : undefined)
	);
}
initState();

window.CHECK_CONFIRM_NAVIGATION = [];

window.addEventListener("beforeunload", evt => {
	for (let callback of window.CHECK_CONFIRM_NAVIGATION) {
		if (callback()) {
			evt.returnValue = true;
			break;
		}
	}
});

function confirmNavigation(): boolean {
	for (let callback of window.CHECK_CONFIRM_NAVIGATION) {
		if (callback()) {
			if (!confirm(
				"Are you sure that you want to leave current page? " +
				"You might lose unsaved data."
			)) {
				return false;
			}
			break;
		}
	}
	return true;
}

function isPageSlug(url: string): boolean {
	return !url.startsWith("api/") && !url.startsWith("uploads/");
}

if ("navigation" in window) {
	console.log("Using Navigation API");
	(window.navigation as any).addEventListener("navigate", (evt: Event) => {
		if (!(evt as any).userInitiated) {
			return;
		}
		if (evt.cancelable) {
			if (!confirmNavigation()) {
				evt.preventDefault();
				return;
			}
		}
		if ((evt as any).canIntercept) {
			const url = new URL((evt as any).destination.url);
			if (!isPageSlug(url.pathname.substring(1))) {
				return;
			}
			if (url.pathname !== location.pathname || url.search !== location.search) {
				(evt as any).intercept({
					handler: async () => {
						const page = await fetchPage(url.pathname.substring(1) + url.search);
						renderPage(page);
						if (
							(evt as any).navigationType === "push" &&
							(url.hash.length === 0 || document.getElementById(url.hash.substring(1)) === null)
						) {
							window.scrollTo(0, 0);
						} else {
							(evt as any).scroll();
						}
						if (makePageUrl(page) !== url.pathname + url.search) {
							history.replaceState(
								null,
								page.title,
								makePageUrl(page, url.hash !== "" ? url.hash : undefined)
							);
						}
					}
				});
			}
		}
	});
} else {
	console.log("Using History API");
	initState();
	document.addEventListener("click", evt => {
		const origin = (evt.target as HTMLElement).closest("a");
		if (origin) {
			if (origin.target === "" || origin.target === "_self") {
				const href = origin.href;
				if (href.startsWith(window.location.origin)) {
					const urlAndHash = href.substring(window.location.origin.length + 1);
					if (!isPageSlug(urlAndHash)) {
						return;
					}
					const hashOffset = urlAndHash.indexOf("#");
					const url = hashOffset < 0 ? urlAndHash : urlAndHash.substring(0, hashOffset);
					const hash = hashOffset < 0 ? "" : urlAndHash.substring(hashOffset);
					if (url !== window.location.pathname.substring(1)) {
						evt.preventDefault();
						if (confirmNavigation()) {
							fetchPage(url).then(response => {
								pushCurrentPage(response, hash !== "" ? hash : undefined);
								if (hash !== "") {
									setTimeout(
										() => {
											const elem = document.getElementById(hash.substring(1));
											if (elem !== null) {
												elem.scrollIntoView();
											} else {
												window.scrollTo(0, 0);
											}
										},
										0
									);
								} else {
									window.scrollTo(0, 0);
								}
							});
						}
					} else if (hash !== "") {
						setTimeout(initState, 1 /* Firefox work-around */);
					} else {
						evt.preventDefault();
					}
				}
			}
		}
	});
	window.addEventListener("popstate", evt => {
		if (evt.state !== null) {
			renderPage(evt.state);
		}
	});
}

renderPagePublicationDate();
